/* @ts-expect-error */
import sha256 from 'crypto-js/sha256';

function hashString(string: string){
  return sha256(string);
}

export default hashString;